<script setup>
  import { onUnmounted } from "vue";
  import { storeToRefs } from "pinia";

  import TemplatesTable from "@/components/Mailing/TemplatesTable.vue";
  import TemplateNew from "@/components/Mailing/TemplateNew.vue";
  import { IndexPageLayout, IndexPageFilters } from "@/components/App/IndexPage";
  import { FilterDropdown } from "@/components/episto-ui/filter-dropdown";
  import { useTemplatesStore } from "@stores/mailing/templates";
  import { useTemplateStore } from "@stores/mailing/template";
  import { useTemplatesFilters } from "@/utils/composables/filters/useTemplatesFilters";

  const templatesStore = useTemplatesStore();
  const templateStore = useTemplateStore();
  const { isNewTemplateVisible } = storeToRefs(templateStore);
  const { templatesSearchQuery } = storeToRefs(templatesStore);
  const { resetAllFilters } = templatesStore;

  const { filterConfigs, activeFiltersCount, handleFilterChange, handleClear } = useTemplatesFilters();

  onUnmounted(() => resetAllFilters());
</script>

<template>
  <IndexPageLayout
    title="Email Templates"
    action-label="New template"
    @action="isNewTemplateVisible = true">
    <template #filters>
      <IndexPageFilters
        v-model:search-model-value="templatesSearchQuery"
        search-placeholder="Search templates">
        <template #filters>
          <FilterDropdown
            :filters="filterConfigs"
            :active-filters-count="activeFiltersCount"
            @toggle="handleFilterChange"
            @clear="handleClear" />
        </template>
      </IndexPageFilters>
    </template>

    <TemplatesTable />

    <template #dialogs>
      <TemplateNew />
    </template>
  </IndexPageLayout>
</template>
